// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p8-8";
export var editMode = "_p8-3";
export var headerRow = "_p8-a";
export var headerTitle = "_p8-b";
export var product = "_p8-1";
export var productDetails = "_p8-5";
export var productDivider = "_p8-7";
export var productImage = "_p8-2";
export var productInfo = "_p8-4";
export var productTitle = "_p8-6";
export var strikethrough = "_p8-9";
export var upsellProductsCard = "_p8-0";